import React, { useMemo, useState } from 'react';
import { ErrorArea, Form, Input, ReformSubmitHandler, Submit } from '@kodkafa/reform';

import {
  ResendDto,
  useAuthControllerVerifyMutation,
  useVerificationControllerResendMutation,
  useVerificationControllerVerifyMutation,
  VerifyDto,
} from '@/store/services/MidleNestApi.service';
import { errorHandler } from '@/utils/error.handler';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCountdown } from '@/hooks/useCountDown';
import { storageLocal } from '@/utils';
import { useProfile } from '@/hooks';

export default function VerifyView() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [getAccounts] = useLazyAuthControllerUnVerifiedAccountsQuery();
  const [verification] = useVerificationControllerVerifyMutation();
  const [verify] = useAuthControllerVerifyMutation();
  const [resend] = useVerificationControllerResendMutation();
  const [email, setEmail] = useState(sessionStorage.getItem('email'));
  const [phone, setPhone] = useState(sessionStorage.getItem('phone'));
  const defaultValues = { data: email || phone || '' };
  const { profile } = useProfile();
  //
  // useEffect(() => {
  //   if (!email && !phone)
  //     getAccounts().then(({ data }) => {
  //       console.log(data?.find((i) => i.provider === 'email')?.identity);
  //       setEmail(data?.find((i) => i.provider === 'email')?.identity || null);
  //       setPhone(data?.find((i) => i.provider === 'phone')?.identity || null);
  //     });
  // }, []);

  const handleSubmit: ReformSubmitHandler<VerifyDto> = async (data, setError) => {
    await verification(data)
      .unwrap()
      .then(async (payload) => {
        if (payload) {
          storageLocal.setItem('accessToken', payload.token);
          await verify()
            .unwrap()
            .then(() => {
              if (data.data.match(/@/)) {
                sessionStorage.removeItem('email');
                setEmail('');
              } else {
                sessionStorage.removeItem('phone');
                setPhone('');
              }
              gtag('event', 'verify', { user: profile.id });
              // if (!sessionStorage.getItem('email')) navigate('/');
              // if all verification is done
              if (!sessionStorage.getItem('email') && !sessionStorage.getItem('phone'))
                navigate('/');
            })
            .catch((error) => errorHandler(error, setError));
        }
      })
      .catch((error) => errorHandler(error, setError));
  };

  const handleResend: ReformSubmitHandler<ResendDto> = async (data, setError) => {
    await resend(data)
      .unwrap()
      .then(async (payload) => {
        console.log('RESEND', { payload });
      })
      .catch((error) => errorHandler(error, setError));
  };

  const verifyForm = useMemo(
    () => (
      <Form
        // new key for remount
        key={'verify-form-' + defaultValues.data}
        onSubmit={handleSubmit}
        defaultValues={defaultValues}
        className='flex !gap-4'
      >
        <div>
          <Input
            name='data'
            label={email ? 'Email address' : 'Phone Number'}
            placeholder={email ? 'jon@doe.com' : '+44'}
            className='w-full'
          />
        </div>
        <div>
          <Input
            name='code'
            label={t('Verification code')}
            placeholder={t('ABCG')}
            className='w-full'
          />
          <Input name='type' value='verify' type='hidden' />
        </div>
        <p className='text-xs text-gray-700 text-center'>
          {t('Check your inbox for the validation code.')}
        </p>
        <ErrorArea />
        <div>
          <Submit>{t('Verify')}</Submit>
        </div>
      </Form>
    ),
    [defaultValues.data],
  );
  // TODO get an available resend date as /resend return
  const date = useMemo(() => {
    const _date = new Date();
    _date.setTime(new Date().getTime() + 180 * 1000);
    return _date;
  }, []);

  const { minutes, seconds, ms } = useCountdown(date.toISOString());

  const reSendForm = useMemo(() => {
    return (
      <Form
        // new key for remount
        key={'resend-form-' + defaultValues.data}
        onSubmit={handleResend}
        className='flex !gap-4'
        defaultValues={defaultValues}
      >
        <Input name='data' className='w-full' type='hidden' />
        <div>
          <Submit disabled={!!ms}>
            {minutes}:{seconds} {t('Re-send Verification')}
          </Submit>
        </div>
      </Form>
    );
  }, [defaultValues.data, seconds]);
  return (
    <div className='flex flex-col py-8 mx-auto w-96 text-sm'>
      <h1 className='text-xl font-bold mb-6 text-center'>{t('Verify')}</h1>
      {verifyForm}
      <hr className='my-4 border-t' />
      {reSendForm}
    </div>
  );
}
